import caseA from "../../images/homepage/caseC.jpg";
import caseB from "../../images/homepage/caseB.jpg";
import caseC from "../../images/homepage/caseA.jpg";

const caseData = [
  {
    bg: caseA,
    caseText: "CASE 01",
    bird: "紅隼",
    text: '協助治療因傷無法飛行的虛弱紅隼，並細心照料直到它能變得強壯，再次飛翔…',
    link: '/kestrel/'
  },
  {
    bg: caseB,
    caseText: "CASE 02",
    bird: `白鼻心`,
    text: '年幼白鼻心，因為遭到土狗的追逐而與母親走散，無法獨自在野外生存…',
    link: '/formosan-masked-civet/'
  },
  {
    bg: caseC,
    caseText: "CASE 03",
    bird: "赤翡翠",
    text: '一隻頸部嚴重受傷且虛弱的赤翡翠，火速被送來野灣動物醫院…',
    link: '/ruddy-kingfisher/'
  }
];

export {caseData};